// Configuration constants
const storageKey = 'selectedPosts';  // Cookie key for storing selected items

// Store initial cookie state to detect changes when page is restored from cache
//let initialCookieState = null;
/**
 * Updates the order form display based on current cookie data
 * This function is called on page load and when page is restored from cache
 */
function updateOrderFormDisplay() {
    const orderFormContainer = document.querySelector('.order-form-container');
    if (orderFormContainer) {
        // Get the value of the selectedPosts cookie
        const selectedPostsCookie = getCookie(storageKey);
        // Find the error container
        const orderFormErrorContainer = document.querySelector('.order-form-error-container');
        const postTypeElement = document.querySelector('[data-elementor-type="wp-post"]');
        let postType = null;
        let displayTabs = false;
        if (postTypeElement) {
            postType = postTypeElement.getAttribute('data-elementor-post-type');
            if (selectedPostsCookie && postType) {
                try {
                    const selectedPostsData = JSON.parse(selectedPostsCookie);
                    if (selectedPostsData && typeof selectedPostsData === 'object' && selectedPostsData[postType]) {
                        displayTabs = true;
                    }
                } catch (e) {
                    console.warn('[Selector] Parsing error:', e);
                }
            }
        }
        if (displayTabs) {
            orderFormContainer.classList.remove('element-hidden');
            if (orderFormErrorContainer) {
                orderFormErrorContainer.classList.add('element-hidden');
            }
        } else {
            orderFormContainer.classList.add('element-hidden');
            if (orderFormErrorContainer) {
                orderFormErrorContainer.classList.remove('element-hidden');
            }
        }
    }
}

/**
 * Main initialization event - runs when DOM is fully loaded
 * Sets up the product selection system by restoring visual state and binding event handlers
 */
document.addEventListener('DOMContentLoaded', function () {
    // Store initial cookie state to detect changes later
    //initialCookieState = getCookie(storageKey);

    // Initialize the product selection system
    restoreVisualSelections(); // Restore selected items from localStorage
    bindAddHandlers();         // Bind click handlers to add buttons
    bindRemoveHandlers();      // Bind click handlers to remove buttons
    console.log('%c[Init] Toggle, visual state, and refresh ready.', 'color: teal;');

    // Update order form display
    updateOrderFormDisplay();
});

/**
 * Gets the post type from the body class
 * @returns {string|null} The post type or null if not found
 */
function getPostType() {
    // We can safely access document.body
    const bodyClasses = document.body.className.split(' ');
    for (let i = 0; i < bodyClasses.length; i++) {
        if ((bodyClasses[i].startsWith('post-type-') && bodyClasses[i] !== 'post-type-archive') || bodyClasses[i].startsWith('single-') ) {
            return bodyClasses[i];
        }
    }
    return null;
}

/**
 * Event listener for page show
 * @param {Event} event - The event object
 * @returns {void}
 * @description This function is used to handle the page show event
 */
 window.addEventListener( "pageshow", function ( event ) {
    var historyTraversal = event.persisted || false;

    // Define array of post types to check against
    const postTypesToCheck = ['fleet', 'studio', 'photo-rental', 'production-supply', 'lighting-grip'];

    if ( historyTraversal ) {
        const currentPostType = getPostType();
        // Check if currentPostType is in postTypesToCheck array
        if (currentPostType && postTypesToCheck.some(type => currentPostType && currentPostType.includes(type))) {
            // Force a reload from the server, bypassing the cache
            window.location.reload(true); 
        }
    }
});

/**
 * Sets a cookie with the given name, value, and expiration days
 * @param {string} name - Cookie name
 * @param {string} value - Cookie value
 * @param {number} days - Days until expiration
 */
function setCookie(name, value, days) {
    let expires = "";
    if (days) {
        const date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
}

/**
 * Gets a cookie value by name
 * @param {string} name - Cookie name
 * @returns {string|null} Cookie value or null if not found
 */
function getCookie(name) {
    const nameEQ = name + "=";
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
}

/**
 * Deletes a cookie by setting expiration to past date
 * @param {string} name - Cookie name
 */
function deleteCookie(name) {
    document.cookie = name + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}

/**
 * Retrieves the stored selection data from cookies
 * @returns {Object} The parsed JSON object or empty object if no data exists
 */
function getStoredObject() {
    const data = getCookie(storageKey);
    return data ? JSON.parse(data) : {};
}

/**
 * Saves the selection data to cookies
 * @param {Object} obj - The object containing selected items data
 */
function saveStoredObject(obj, needReload) {
    setCookie(storageKey, JSON.stringify(obj), 2); // 2 days expiration
    if (needReload) {
        location.reload();
    }
}

/**
 * Gets all selected post IDs from localStorage (new format only)
 * @returns {Array} Array of unique post IDs that are currently selected
 */
function getSelectedIds() {
    const stored = getStoredObject();
    let ids = [];
    for (const type in stored) {
        if (typeof stored[type] === 'object') {
            // Handle new format (objects with quantities) - extract keys as IDs
            ids = ids.concat(Object.keys(stored[type]).map(id => parseInt(id)));
        }
    }
    return [...new Set(ids)]; // Remove duplicates and return unique IDs
}

/**
 * Gets all selected post IDs with their quantities from localStorage (new format only)
 * @returns {Object} Object with post IDs as keys and quantities as values
 */
function getSelectedWithQuantities() {
    const stored = getStoredObject();
    let result = {};
    for (const type in stored) {
        if (typeof stored[type] === 'object') {
            // New format - merge quantities across all post types
            for (const id in stored[type]) {
                result[id] = (result[id] || 0) + stored[type][id];
            }
        }
    }
    return result;
}


/**
 * Updates the selection state of a post (add, remove, or toggle)
 * Manages quantities, visual state, and localStorage storage
 * @param {HTMLElement} wrapper - The wrapper element containing the post
 * @param {number} postId - The post ID to update
 * @param {string} postType - The post type (e.g., 'product', 'service')
 * @param {HTMLElement} postDataDiv - The post data element for visual updates
 * @param {string} action - Action to perform: 'add', 'remove', or 'toggle' (default)
 */
function updateSelection(wrapper, postId, postType, postDataDiv, action = 'toggle') {
    const stored = getStoredObject();

    // Initialize postType as object if it doesn't exist or is still an array (old format)
    if (!stored[postType] || Array.isArray(stored[postType])) {
        stored[postType] = {};
    }

    const currentQuantity = stored[postType][postId] || 0;
    let needReload = false;

    if (action === 'add') {
        // Increment quantity by 1
        let newQuantity = currentQuantity + 1;
        stored[postType][postId] = newQuantity;
        wrapper.querySelector('.product-quantity').value = newQuantity;
        console.log(`%c[✔ Added] Post ID ${postId} to ${postType} (Qty: ${stored[postType][postId]})`, 'color: green;');
    } else if (action === 'remove') {
        // Decrement quantity by 1
        if (currentQuantity > 0) {
            let newQuantity = currentQuantity - 1;
            stored[postType][postId] = newQuantity;
            if (stored[postType][postId] === 0) {
                // Remove completely when quantity reaches 0
                wrapper.querySelector('.product-quantity').value = '';
                delete stored[postType][postId];
                if (document.querySelector('.product-selection-form')) {
                    needReload = true;
                }

                // Clean up empty post type objects from localStorage
                if (Object.keys(stored[postType]).length === 0) {
                    delete stored[postType];
                }
            } else {
                // Update quantity display
                wrapper.querySelector('.product-quantity').value = newQuantity;
            }
        }
    } else {
        // Toggle behavior (for backward compatibility) - completely add/remove
        const addButton = wrapper.querySelector('.add-product');
        const addButtonText = addButton.querySelector('.elementor-button-text');
        const addedLabel = addButton.getAttribute('added-label');
        const addLabel = addButton.getAttribute('add-label');
        
        if (currentQuantity > 0) {
            // Remove completely
            delete stored[postType][postId];

            // Clean up empty post type objects
            if (Object.keys(stored[postType]).length === 0) {
                delete stored[postType];
            }
            if (document.querySelector('.product-selection-form')) {
                needReload = true;
            }
            wrapper.classList.remove('product-added');
            if (addButtonText && addLabel) {
                addButtonText.textContent = addLabel;
            }
        } else {
            // Add with quantity 1
            stored[postType][postId] = 1;
            wrapper.classList.add('product-added');
            if (addButtonText && addedLabel) {
                addButtonText.textContent = addedLabel;
            }
        }
    }

    // Update the selected-posts-count display
    updateSelectedPostsCount(stored, postType);

    saveStoredObject(stored, needReload); // Save updated data to localStorage
}

/**
 * Restores the visual state of selected items when the page loads
 * Reads from localStorage and updates visual styling and quantity inputs
 */
function restoreVisualSelections() {
    const stored = getStoredObject();
    document.querySelectorAll('.post-data').forEach(div => {
        const postId = parseInt(div.getAttribute('data-post-id'), 10);
        const postType = div.getAttribute('data-post-type');
        const wrapper = div.closest('.quixote-lb-product-container');

        if (!wrapper) return; // Skip if no wrapper found

        if (stored && stored[postType] && typeof stored[postType] === 'object') {
            if (stored[postType][postId] && stored[postType][postId] > 0) {
                if (postType === 'studio') {
                    const addButton = wrapper.querySelector('.add-product');
                    const addButtonText = addButton.querySelector('.elementor-button-text');
                    const addedLabel = addButton.getAttribute('added-label');
                    if (
                        stored[postType] &&
                        stored[postType][postId]
                    ) {
                        wrapper.classList.add('product-added');
                        if (addButtonText && addedLabel) {
                            addButtonText.textContent = addedLabel;
                        }
                    }
                } else {
                     // Handle new format (objects with quantities)
                    const quantityInput = wrapper.querySelector('.product-quantity');
                    if (quantityInput) {
                        quantityInput.value = stored[postType][postId]; // Set quantity value
                    }
                }
            }
        }
    });
}

/**
 * Binds click event handlers to all add product buttons
 * Prevents duplicate event binding and handles product addition
 */
function bindAddHandlers() {
    document.querySelectorAll('.add-product a').forEach(anchor => {
        // Prevent duplicate event binding
        if (anchor.dataset.init === '1') return;
        anchor.dataset.init = '1';

        // Add click event listener for adding products
        anchor.addEventListener('click', function (e) {
            e.preventDefault(); // Prevent default link behavior
            const wrapper = anchor.closest('.quixote-lb-product-container');
            const postData = wrapper.querySelector('.post-data');

            if (!postData) return; // Exit if no post data found

            // Extract post information from data attributes
            const postId = parseInt(postData.getAttribute('data-post-id'), 10);
            const postType = postData.getAttribute('data-post-type');

            if (!isNaN(postId) && postType) {
                if (postType === 'studio') {
                    updateSelection(wrapper, postId, postType, postData, 'toggle'); // Add product
                } else {
                    updateSelection(wrapper, postId, postType, postData, 'add'); // Add product
                }
            }
        });
    });
}

/**
 * Binds click event handlers to all remove product buttons
 * Prevents duplicate event binding and handles product removal
 */
function bindRemoveHandlers() {
    document.querySelectorAll('.remove-product a').forEach(removeElement => {
        // Prevent duplicate event binding
        if (removeElement.dataset.init === '1') return;
        removeElement.dataset.init = '1';

        // Add click event listener for removing products
        removeElement.addEventListener('click', function (e) {
            e.preventDefault(); // Prevent default link behavior
            const wrapper = removeElement.closest('.quixote-lb-product-container');
            const postData = wrapper.querySelector('.post-data');

            if (!postData) return; // Exit if no post data found

            // Extract post information from data attributes
            const postId = parseInt(postData.getAttribute('data-post-id'), 10);
            const postType = postData.getAttribute('data-post-type');

            if (!isNaN(postId) && postType) {
                updateSelection(wrapper, postId, postType, postData, 'remove'); // Remove product
            }
        });
    });
}

/**
 * Updates the text of div with class 'selected-posts-count' with the count for the specified post type
 * @param {string} postType - The post type to count
 */
function updateSelectedPostsCount(stored, postType) {
    const countElements = document.querySelectorAll('.selected-posts-count');
    if (countElements.length === 0) return;

    const postTypeData = stored[postType] || {};

    // Calculate total count for this post type
    let uniquePostCount = 0;
    for (const postId in postTypeData) {
        if (postTypeData[postId] && postTypeData[postId] > 0) {
            uniquePostCount++;
        }
    }

    // Update all elements with the class
    countElements.forEach(element => {
        element.textContent = uniquePostCount;
    });
}

/**
 * Event listener for FacetWP content updates
 * Restores visual state of selected items when FacetWP refreshes the loop results
 */
(function() {
    let firstFacetWpLoaded = true;
    document.addEventListener('facetwp-loaded', function () {
        // Re-bind event handlers for new elements
        bindAddHandlers();
        bindRemoveHandlers();

        // Restore visual selections (quantity inputs) for the new content
        restoreVisualSelections();

        // Only scroll to top on subsequent loads, not the first
        if (firstFacetWpLoaded) {
            firstFacetWpLoaded = false;
        } else {
            const orderFormTabs = document.querySelector('.quixote-order-form-tabs');
            if (orderFormTabs) { 
                goToTop('.e-n-tabs-heading');
            } else {
                goToTop('.quixote-filter-container');
            }
        }
    });

    document.querySelector('.facetwp-type-sort select')?.setAttribute('aria-label', 'Sort products by');
})();


jQuery(document).ready(function($){
    $(document).on( 'frmBeforeFormRedirect', function( event, form, response ) {
        const stored = getStoredObject();
        const postType = document.querySelector('[data-elementor-type="wp-post"]').getAttribute('data-elementor-post-type');
        if (stored && postType && stored[postType]) {
            delete stored[postType];
            saveStoredObject(stored, false);
        }
    });
});